import type { DefaultToastOptions } from 'react-hot-toast';

export const appToastOptions: DefaultToastOptions = {
  duration: 3000,
  className: 'dark:bg-gray-800 dark:text-white dark:border dark:border-gray-700 !pr-9',
  style: {
    maxWidth: 'min(420px, calc(100vw - 32px))',
  },
  success: {
    duration: 3000,
  },
  error: {
    duration: 4000,
  },
};
